<template>
  
  <nav-bar :returnAction="true" :saveAction="true" :pageName="'Cadastro de Agendamento'" @save="execute" @return="$router.push(`/schedulings`)"/>

  <main-container :onlyNav="true">
    <template v-slot >
      <div class="row w-100">
        <div class="col-sm-12 col-md-12 mb-3" >
          <label for="recipient-name" class="form-label fw-bold">Selecione o Paciente</label>
          <select class="form-select" v-model="scheduling.patientId">
            <option v-for="(obj, index) in patientStore.patients" :value="obj.id" :key="index">{{`${obj.name}`}}</option>
          </select>
        </div>
        <template v-for="item in dates" v-bind:key="item.idx">
          <scheduling-dates-input
              :idx="item.idx"
              :module="'Agendamento'"
              :iniStartDate="item.startDate"
              :ini-end-date="item.endDate"
              :read-only="executeMethod != 'create'"
              @value-obj="alterDate"
              @delete="removeDate"
          />
        </template>
        <div class="d-flex justify-content-end" v-if="executeMethod == 'create'">
            <button class="btn btn-sm btn-primary" v-on:click="addDate">Replicar</button>
        </div>
      </div>
    </template>
  </main-container>
    
</template>

<script>
import { getInstance } from "../../api/api"
import { showErrorNotificationsWithTitle, showErrorNotifications, showErrorModal } from "../../services/popups";
import timeMixins from "../../services/time";
import {  } from "../../services/formatters";
import SchedulingDatesInput from "../../components/Inputs/SchedulingDatesInput";
import { indexOf } from "lodash";
import { usePatientStore } from '@/store/patient';
import { useUserStore } from '../../store/user';

const api = getInstance();

export default {
    name:"SchedulingCrudView",
    mixins:[timeMixins],
    inject:["mySpinner"],
    components: {      
      SchedulingDatesInput,
    },
    setup() {
      const patientStore = usePatientStore();
      const userStore = useUserStore();

      return { patientStore, userStore }
    },
    props: {
        schedulingId: {
          type:String
        }
    },
    async mounted() {
        this.cleanFields();
        this.addDate();        
        await this.patientStore.getPatients(this.userStore.getUser.clinicId);
        if (this.schedulingId != "create") {
          this.executeMethod = "update";
          await this.getSchedulingById(this.schedulingId);
        }
        else {
          this.executeMethod = "create";
        }
    },
    data() {
        return {
          scheduling: {},
          executeMethod: "create",
          patients: [],
          dates:[]
        }
    },
    methods: {
      cleanFields() {
          this.scheduling = {
              id: "",
              patientId: "",
              userId: "",
              title:"AGENDAMENTO",
              dates:[]
          }
      },
      async getSchedulingById(id) {
          this.mySpinner.loading = true;

          try {
              let response = await api.get("v1/Scheduling/Id", { params: { schedulingId:id } });

              this.mySpinner.loading = false;

              if (!response.data.success) {
                showErrorModal(response.data.message);
              }
              else {
                this.scheduling = response.data.data;
                let date = {
                  idx:1,
                  startDate:this.scheduling.startDate,
                  endDate:this.scheduling.endDate
                }
                this.dates = [];
                this.dates.push(date);
              }

          } catch {
              this.mySpinner.loading = false;              
          }
      },
      async getPatients() {
          this.mySpinner.loading = true;

          try {
              let response = await api.get("v1/Patient/Summary", { params: { clinicId: this.userStore.getUser.clinicId } })

              this.mySpinner.loading = false;

              if (response.data.success) {
                this.$store.commit('setPatients',response.data.data);
              }
          } catch {
              this.mySpinner.loading = false;              
          }
      },
      async execute() {
          if (this.executeMethod == "create") { await this.executeCreate(); }
          else { await this.executeUpdate(); }
      },
      async executeCreate() {
        this.scheduling.title = "AGENDAMENTO";
        this.scheduling.dates = this.dates;
        let notifications = [];

        if (!this.scheduling.patientId) {
            notifications.push({key:"PatientId", message:"O paciente deve ser informado!"});
        }
        if (this.scheduling.dates.length === 0) {
            notifications.push({key:"Dates", message:"Ao menos uma Data de agendamento deve ser preenchida!"});
        }

        let correctDates = true;

        for(let index = 0; index < this.scheduling.dates.length; index++) {
          if (!this.scheduling.dates[index].startDate || !this.scheduling.dates[index].endDate) {
            correctDates = false;
            break;
          }
        }

        if (!correctDates) {
          notifications.push({key:"Dates", message:"Existem datas inválidas, verifique!"});
        }

        if (notifications.length > 0) {
            showErrorNotifications(notifications);
            return;
        }

        this.mySpinner.loading = true;

        try {
            let response = await api.post("v1/Scheduling", {...this.scheduling, userId:this.userStore.getUser.id })

            this.mySpinner.loading = false;

            if (!response.data.success) {
                if (response.data.data) {
                  response.data.data.forEach(item => {
                    showErrorNotificationsWithTitle(`Agendamento ${item.idx}`, item.notifications);
                  })
                }
                else {
                  showErrorModal(response.data.message);
                }
            }
            else {
              this.$router.push("/schedulings");
            }
        } catch {
            this.mySpinner.loading = false;            
        }
      },
      async executeUpdate() {

          let notifications = [];
          this.scheduling.startDate = this.dates[0].startDate;
          this.scheduling.endDate = this.dates[0].endDate;

          if (!this.scheduling.patientId) {
              notifications.push({key:"PatientId", message:"O paciente deve ser informado!"});
          }

          if (!this.scheduling.startDate) {
              notifications.push({key:"StartDate", message:"A Data de início deve ser informada!"});
          }

          if (!this.scheduling.endDate) {
              notifications.push({key:"EndDate", message:"A Data de Término deve ser informada!"});
          }

          if (this.scheduling.endDate < this.scheduling.startDate) {
              notifications.push({key:"Dates", message:"A Data de Término deve ser maior que a Data de Início!"});
          }

          if (notifications.length > 0) {
            showErrorNotifications(notifications);
            return;
          }

          this.scheduling.title = "AGENDAMENTO";

          this.mySpinner.loading = true;

            try {
                let response = await api.put("v1/Scheduling", {...this.scheduling, userId:this.userStore.getUser.id })

                this.mySpinner.loading = false;

                if (!response.data.success) {
                  if (response.data.notifications) {
                    showErrorNotifications(response.data.notifications);
                  }
                  else {
                    showErrorModal(response.data.message);
                  }
                }
                else {
                  this.$router.push("/schedulings");
                }
            } catch {
                this.mySpinner.loading = false;                
            }
      },
      addDate() {
        if (this.dates.length == 0) {
          this.dates.push({idx:1, startDate:"", endDate:""});
          return;
        }
        let lastDate = this.dates[this.dates.length - 1];
        if (lastDate && lastDate.startDate && lastDate.endDate) {
          this.dates.push(
            {
              idx:lastDate.idx + 1,
              startDate: this.addDays(lastDate.startDate, 7),
              endDate: this.addDays(lastDate.endDate, 7)
            }
          );
        }
        else {showErrorModal("Preencha as datas antes de replicar!");}
      },
      alterDate(valueObj) {
        let foundItem = this.dates.find(x => x.idx == valueObj.idx);
        foundItem ? this.dates[indexOf(this.dates, foundItem)] = valueObj : this.dates.push(valueObj);
      },
      async removeDate(idx) {
        let confirm = await this.confirmOperation("Confirmação", "Deseja relamente excluir o item selecionado ?");
        if (!confirm)
            return;
        this.dates = this.dates.filter(item => item.idx != idx);
        let resetedIdx = 1;
        this.dates.forEach(item => {
          item.idx = resetedIdx;
          resetedIdx++;
        });
      }
    },
}
</script>

<style lang="css" scoped>
    @import'../../assets/css/_colors';
    @import'../../assets/css/_schedulings';
</style>
